import React, {useEffect, useState} from 'react';
import {usePage} from "@inertiajs/react";
import {PageProps} from "@/types";

const FlashMessage:React.FC = () => {
    const {flash} = usePage<PageProps>().props

    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (flash?.notice || flash?.alert) {
            setVisible(true);
            const timer = setTimeout(() => setVisible(false), 5000);
            return () => clearTimeout(timer);
        }
    }, [flash]);

    if (!visible || (!flash?.notice && !flash?.alert)) {
        return null;
    }

    return (
        <div className="fixed top-4 right-4 z-50">
            {flash.notice && (
                <div className="bg-green-50 border border-green-200 rounded-md p-4 mb-4">
                    <div className="flex">
                        <div className="text-sm text-green-600">{flash.notice}</div>
                        <button
                            onClick={() => setVisible(false)}
                            className="ml-4 text-green-400 hover:text-green-600"
                        >
                            ×
                        </button>
                    </div>
                </div>
            )}
            {flash.alert && (
                <div className="bg-red-50 border border-red-200 rounded-md p-4">
                    <div className="flex">
                        <div className="text-sm text-red-600">{flash.alert}</div>
                        <button
                            onClick={() => setVisible(false)}
                            className="ml-4 text-red-400 hover:text-red-600"
                        >
                            ×
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default FlashMessage;